<div class="invoice-preview" [class.dialog-mode]="isDialogMode">
  <div class="preview-shell">
    <div class="preview-header">
      <div class="header-copy">
        <p class="eyebrow">Sales Invoice</p>
        <div class="header-title-row">
          <h2>Professional Print Preview</h2>
          <div class="toolbar" aria-label="Invoice actions">
            <mat-slide-toggle
              class="sign-toggle"
              color="primary"
              [checked]="includeSignature"
              [disabled]="isGenerating"
              (change)="onSignatureToggle($event.checked)">
              Sign + Stamp
            </mat-slide-toggle>
            <mat-slide-toggle
              *ngIf="hasPosAnnexure"
              class="sign-toggle"
              color="accent"
              [checked]="includePosAnnexure"
              [disabled]="isGenerating"
              (change)="onPosAnnexureToggle($event.checked)">
              POS Annexure
            </mat-slide-toggle>
            <button mat-raised-button color="primary" (click)="printPdf()">Print</button>
            <button mat-stroked-button color="primary" (click)="downloadPdf()">Download PDF</button>
            <button mat-flat-button color="accent" (click)="sendMail()">Mail Invoice</button>
            <button
              *ngIf="isDialogMode"
              mat-icon-button
              type="button"
              class="close-preview-button"
              aria-label="Close preview"
              (click)="closePreview()">
              <mat-icon svgIcon="mat:close"></mat-icon>
            </button>
          </div>
        </div>
        <p class="subtext">
          Default preview loads without sign for speed. Turn on `Sign + Stamp` only when you need the signed invoice.
        </p>
      </div>
    </div>

    <div class="preview-frame" *ngIf="previewData; else loading">
      <div class="invoice-page">
        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="invoice-head">
          <div class="logo-cell">
            <img *ngIf="previewData.logo; else logoFallback" [src]="previewData.logo" alt="Company Logo" />
            <ng-template #logoFallback>
              <div class="logo-fallback">{{ previewData.companyInitials }}</div>
            </ng-template>
          </div>

          <div class="company-cell">
            <h1>{{ previewData.companyName }}</h1>
            <p *ngIf="previewData.companyAddress">{{ previewData.companyAddress }}</p>
            <p *ngFor="let meta of previewData.companyMeta">{{ meta }}</p>
          </div>

          <div class="invoice-meta-box">
            <h2>TAX INVOICE</h2>
            <p><strong>Invoice No:</strong> {{ previewData.billNo }}</p>
            <p><strong>Invoice Date:</strong> {{ previewData.billDate }}</p>
            <p *ngIf="previewData.status"><strong>Status:</strong> {{ previewData.status }}</p>
            <p *ngIf="previewData.placeOfSupply"><strong>Place of Supply:</strong> {{ previewData.placeOfSupply }}</p>
          </div>
        </div>

        <div class="party-grid">
          <section>
            <h3>Bill To</h3>
            <h4>{{ previewData.clientName }}</h4>
            <p *ngIf="previewData.clientAddress">{{ previewData.clientAddress }}</p>
            <p *ngFor="let line of previewData.clientMeta">{{ line }}</p>
          </section>

          <section>
            <h3>Ship To</h3>
            <h4>{{ previewData.shipToName }}</h4>
            <p *ngIf="previewData.shipToAddress">{{ previewData.shipToAddress }}</p>
            <p *ngFor="let line of previewData.shipToMeta">{{ line }}</p>
          </section>
        </div>

        <table class="items-table">
          <thead>
            <tr>
              <th>SR</th>
              <th>DESCRIPTION</th>
              <th>HSN/SAC</th>
              <th>QTY</th>
              <th>RATE</th>
              <th>TAXABLE</th>
              <th>TAX</th>
              <th>TAX TYPE</th>
              <th>LINE TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of previewData.items">
              <td class="center">{{ item.sr }}</td>
              <td>{{ item.description }}</td>
              <td class="center">{{ item.hsn }}</td>
              <td class="right">{{ item.qty }}</td>
              <td class="right">{{ item.rate }}</td>
              <td class="right">{{ item.taxable }}</td>
              <td class="right">{{ item.tax }}</td>
              <td class="center">{{ item.taxType }}</td>
              <td class="right strong">{{ item.lineTotal }}</td>
            </tr>
            <tr class="grand-row">
              <td colspan="8" class="right">GRAND TOTAL</td>
              <td class="right">{{ previewData.netAmount }}</td>
            </tr>
          </tbody>
        </table>

        <div class="bottom-grid">
          <div class="details-block">
            <section>
              <h3>Bank Details</h3>
              <p *ngFor="let line of previewData.bankDetails">{{ line }}</p>
            </section>
            <section class="words-block">
              <h3>Amount In Words</h3>
              <p>{{ previewData.amountInWords }}</p>
            </section>
          </div>

          <div class="summary-sign-block">
            <table class="summary-table">
              <tr *ngFor="let row of previewData.summary">
                <td>{{ row.label }}</td>
                <td>{{ row.value }}</td>
              </tr>
            </table>

            <div class="html-sign-area">
              <div class="sign-company">For {{ previewData.companyNameTitle }}</div>
              <div class="sign-assets" *ngIf="includeSignature">
                <img *ngIf="previewData.stampImage" class="stamp-img" [src]="previewData.stampImage" alt="Company Stamp" />
                <img *ngIf="previewData.signatureImage" class="signature-img" [src]="previewData.signatureImage" alt="Signature" />
              </div>
              <div class="sign-name">{{ previewData.signatoryName }}</div>
              <div class="sign-role" *ngIf="previewData.signatoryTitle">{{ previewData.signatoryTitle }}</div>
            </div>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>Page 1 of 1</span>
          </div>
        </div>
      </div>

      <div class="invoice-page annexure-page" *ngIf="includePosAnnexure && hasPosAnnexure">
        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="annexure-head">
          <div>
            <p class="eyebrow">POS Postpaid Annexure</p>
            <h2>{{ previewData.companyNameTitle }}</h2>
            <p>Invoice No: {{ previewData.billNo }} | Date: {{ previewData.billDate }}</p>
          </div>
          <div class="annexure-meta">
            <p><strong>Client:</strong> {{ previewData.clientName }}</p>
            <p *ngIf="previewData.shipToMeta?.length">{{ previewData.shipToMeta[previewData.shipToMeta.length - 1] }}</p>
          </div>
        </div>

        <section class="annexure-section" *ngIf="previewData.posCardSummary?.length">
          <h3>Card-wise POS Summary</h3>
          <table class="items-table annexure-table">
            <thead>
              <tr>
                <th>SR</th>
                <th>CARD UID</th>
                <th>HOLDER CODE</th>
                <th>HOLDER NAME</th>
                <th>ORDERS</th>
                <th>NET AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of previewData.posCardSummary">
                <td class="center">{{ item.sr }}</td>
                <td>{{ item.cardUid }}</td>
                <td class="center">{{ item.holderCode }}</td>
                <td>{{ item.holderName }}</td>
                <td class="right">{{ item.totalOrders }}</td>
                <td class="right strong">{{ item.netAmount }}</td>
              </tr>
            </tbody>
          </table>
        </section>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>POS Annexure Preview</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-state">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="loading-text">{{ includeSignature ? 'Generating signed invoice preview...' : 'Generating invoice preview...' }}</p>
    </div>
  </ng-template>
</div>
